export const suggestedPrompts = [
  "What plans do you offer?",
  "Can I book a demo?",
  "Do you integrate with HubSpot?",
  "I'd like to talk to a human",
];

const rules = [
  {
    test: /price|pricing|cost|plan/i,
    reply:
      "We offer three plans — Starter, Business, and Enterprise. The Business plan starts at $79/user/month and includes CRM integrations and priority support. Want me to show the full comparison?",
  },
  {
    test: /demo/i,
    reply: "I'd be happy to set up a demo! What day and time works best for you this week?",
  },
  {
    test: /integrat|hubspot|salesforce|slack|zapier/i,
    reply:
      "Hostor integrates with HubSpot, Salesforce, and Slack out of the box, plus Zapier for everything else. Which tool are you looking to connect?",
  },
  {
    test: /\b(hi|hello|hey)\b/i,
    reply: "Hi there! 👋 I'm Maya, GoPointr's AI receptionist. How can I help you today?",
  },
  {
    test: /human|agent|person|talk to (a )?(someone|rep)/i,
    reply: "Of course — I can connect you with a member of our team. Could you share your email so they can follow up?",
  },
  {
    test: /thank/i,
    reply: "You're very welcome! Let me know if there's anything else I can help with.",
  },
  {
    test: /bye|goodbye/i,
    reply: "Take care! Feel free to come back anytime you have more questions. 👋",
  },
];

const fallback =
  "Got it! Let me look into that for you. In the meantime, is there anything specific about pricing, integrations, or a demo I can help with?";

export function getBotReply(userText) {
  const match = rules.find((rule) => rule.test.test(userText));
  return match ? match.reply : fallback;
}
